import { formatDisplayDateTime } from '@/utils/date'
import { expandURI } from '@/utils/ajax'

export const batchManagerMixin = {
  data() {
    return {
      batchForm: {
        jobDesc: '',
        runningType: 'N',
        jobSchedule: new Date(),
        jobScheduleTime: '',
        jobKeys: {},
        skipValidate: false
      },
      warningMsg1: 'Previous job(s) has been executed using these parameters.',
      warningMsg2: 'Are you sure you want to execute using these same parameters again?',
      warningMsg3: 'Are you sure you want to {} this batch job?',
      bchJobDetails: [],
      action: '',
      selectedRemove: {},
      selectedTerminate: {},
      promptRemove: false,
      promptTerminate: false,
      promptResubmit: false,
      promptExeJob: false,
      batchStatus: [],
      heapSizes: [2, 4, 6, 8, 10],
      runningType: [
        { label: 'Immediate', value: 'N' },
        { label: 'Schedule', value: 'S' }
      ]
    }
  },
  methods: {
    getBchJobDetails(batches) {
      this.bchJobDetails = []
      if (batches.length > 0) {
        batches.map((data) => {
          if (this.bchJobDetails.length < 3) {
            let detail = 'Batch Job ID [' + data.jobId + '] @ ' + this.formatDateTime(data.jobStart)
            this.bchJobDetails.push(detail)
          }
        })
      }
    },
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    },
    doRemove(action, item) {
      this.action = action
      this.selectedRemove = item
      this.promptRemove = true
    },
    canRemove(data) {
      return !(data.jobStatus === 'P' || data.jobStatus === 'W' || data.jobStatus === 'S')
    },
    canCancel(data) {
      return data.jobStatus === 'W'
    },
    canTerminate(data) {
      return data.jobStatus === 'P'
    },
    canRetry(data) {
      return data.jobStatus === 'FP' || data.jobStatus === 'T'
    },
    canUnscheduled(data) {
      return data.jobStatus === 'S'
    },
    async doUnscheduled(action, item) {
      if (this.$store.state.batchManager.init === 0) {
        await Promise.all([this.$store.dispatch('batchManagerInit')])
      }
      const apiUrl = this.batchmenu.bchMngJobUnscheduled
      if (apiUrl) {
        try {
          const expand = {
            jobId: action + '-' + item.jobId
          }
          const result = await this.$http.post(expandURI(apiUrl, expand))
          const { data } = result
          this.notify(data)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    },
    async proceedRemove() {
      if (this.$store.state.batchManager.init === 0) {
        await Promise.all([this.$store.dispatch('batchManagerInit')])
      }
      const apiUrl = this.batchmenu.bchMngJobRemove
      if (apiUrl) {
        try {
          const expand = {
            jobId: this.action + '-' + this.selectedRemove.jobId
          }
          const result = await this.$http.delete(expandURI(apiUrl, expand))
          const { data } = result
          this.notify(data)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    },
    async getJobStatus() {
      if (this.$store.state.batchManager.init === 0) {
        await Promise.all([this.$store.dispatch('batchManagerInit')])
      }
      const apiUrl = this.batchmenu.batchStatus
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (data) {
            data.map(d => {
              this.batchStatus.push(d)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async doRetry(item) {
      if (this.$store.state.batchManager.init === 0) {
        await Promise.all([this.$store.dispatch('batchManagerInit')])
      }
      const apiUrl = this.batchmenu.bchMngJobRetry
      if (apiUrl) {
        try {
          const expand = {
            jobId: item.jobId
          }
          const result = await this.$http.post(expandURI(apiUrl, expand))
          const { data } = result
          this.notify(data)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    },
    doAccept() {
      this.batchForm.skipValidate = true
      this.doSubmit()
    },
    getWarningText() {
      let oldwarning = this.warningMsg3
      return oldwarning.replace('{}', this.action)
    }
  },
  computed: {
    batchmenu() {
      return this.$store.state.batchManager.menu
    },
    notifmenu() {
      return this.$store.state.user.notification.menu
    },
    isBatchManager() {
      return this.$store.state.app.dataMap.isBatchManager
    }
  }
}
